<template>
    <rkm-area
        no-margin-top
        title="Declarações de comparecimento"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.plano.declaracoesComparecimento"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.entrada"
                                    label="Entrada"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.saida"
                                    label="Saída"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.turno
                                        ? item.turno.nome : 'Horário personalizado'"
                                    label="Turno"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => item.nomeAcompanhante"
                                    label="Nome do acompanhante"
                                />
                            </rkm-col>

                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.motivoComparecimento"
                                    label="Motivo do comparecimento"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>